export const ComponentTest = () => {
  return "Page dédiée au test de composant";
};
